// Copyright (c) Move Closer 2022.

import { Module } from 'vuex'

import { State } from '../shared/contracts/store'

import { RootState } from './contracts/store'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const storeFactory = (): Module<RootState, State> => ({
  namespaced: true,

  state: () => ({
    loaderConfig: {
      isLoaderVisible: false,
      hasLoaderOpacity: true,
      hasDarkLoader: false
    }
  }),

  mutations: {
    setLoaderOn (state, payload) {
      state.loaderConfig = {
        isLoaderVisible: true,
        hasLoaderOpacity: !!(payload && payload.hasLoaderOpacity),
        hasDarkLoader: false

      }
    },
    setLoaderOff (state) {
      state.loaderConfig = {
        isLoaderVisible: false,
        hasLoaderOpacity: state.loaderConfig.hasLoaderOpacity,
        hasDarkLoader: false
      }
    }
  },

  getters: {
    getLoaderState: state => state.loaderConfig
  }
})
